
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const MaintenancePage = lazy(() => import('../pages/maintenance/page'));

const routes: RouteObject[] = [
  {
    path: '*',
    element: <MaintenancePage />,
  },
];

export default routes;
